import React from "react";

export function SearchIcon({ color = '#FFF', ...props }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke={color} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.5 9.57072C10.4257 8.66326 11 7.3987 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C7.36273 11 8.59812 10.4548 9.5 9.57072ZM9.5 9.57072L13 13" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
